import * as React from "react";
import { Auth } from "aws-amplify";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { MainComponentContainer } from "../../shared/MainComponentContainer";
import {
  Button,
  message,
  Skeleton,
  Row,
  Col,
  Avatar,
  Typography,
  Divider
} from "antd";
import { Shipper } from "../../lib/model/Shipper";
import { ApiClient } from "../../lib/api";
import { ShipperMember } from "../../lib/model/ShipperMember";

const { Title, Text } = Typography;

const client = new ApiClient();

type State = {
  shipper?: Shipper;
  member?: ShipperMember;
};

type Props = RouteComponentProps & {};

class AccountContainer extends React.Component<Props, State> {
  readonly state: State = {};
  render() {
    const { shipper, member } = this.state;
    return (
      <MainComponentContainer>
        <div style={{ padding: "30px" }}>
          <Skeleton active loading={shipper === undefined}>
            {shipper && member && (
              <>
                <Row type="flex" align="middle">
                  <Col span={3} xs={6} md={3} style={{ textAlign: "right", paddingRight: "10px" }}>
                    <Avatar size={64} icon="user" />
                  </Col>
                  <Col span={21} xs={18} md={21}>
                    <Title level={4} style={{ marginBottom: 0 }}>{`${
                      member.firstName
                    } ${member.lastName}`}</Title>
                    <Text>{member.email}</Text>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={21} push={3}>
                    <Divider />
                    <Text strong>Kundennummer</Text>
                    <br />
                    <Text>{shipper.shortId}</Text>
                    <br />
                    <br />
                    <Text strong>Rechnungsadresse</Text>
                    <br />
                    <Text>{shipper.companyName}</Text>
                    <br />
                    <Text>{`${shipper.billingInfo.street} ${
                      shipper.billingInfo.houseNumber
                    }`}</Text>
                    <br />
                    <Text>{`${shipper.billingInfo.city} ${
                      shipper.billingInfo.zipCode
                    }`}</Text>
                    <br />
                    <Text>{shipper.email}</Text>
                    <br />
                    <br />
                    <br />
                    <Button type="danger" onClick={this.signOut}>
                      Abmelden
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </Skeleton>
        </div>
      </MainComponentContainer>
    );
  }
  componentDidMount() {
    this.loadUser();
  }
  signOut = async () => {
    try {
      await Auth.signOut();
      this.props.history.push("/");
    } catch (error) {
      message.error(JSON.stringify(error));
    }
  };
  loadUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      console.log(JSON.stringify(user));
      const shipper = await client.fetchShipperAccount();
      const member = shipper.members.find(
        m => m.cognitoId === user.attributes.sub
      );
      this.setState({ shipper, member });
    } catch (error) {
      message.error(error.message);
    }
  };
}

export default withRouter(AccountContainer);
